import { GameData } from '../../../lib/game-data/game-data';
import { Episode01 } from './Episode01';

export const Game02 = new GameData({
  id: 'Game02',
  episodes: [Episode01],
});
